var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurn = function SvgBurn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.802 5.654C12.146 4.843 11 3 9.5 1.5S7.907 6.448 7 7.5C5.84 8.845 3.854 4.844 3.198 5.656A5.694 5.694 0 0 0 2 9.159C2 12.38 4.692 15 8 15s6-2.621 6-5.843a5.685 5.685 0 0 0-1.198-3.503Z",
    clipRule: "evenodd"
  })));
};
export default SvgBurn;